'use client';

import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/utils/ui-utils';

const containerVariants = cva(
  'relative my-10 w-full flex grow flex-col space-y-10 print:m-0 print:space-y-0 print:p-0',
  {
    variants: {
      variant: {
        default: 'max-w-[90rem] w-full',
        article: 'max-w-[45rem] w-full',
        fullWidth: 'min-w-full',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

interface PageMainContainerProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof containerVariants> {
  outerClassName?: string;
  children: React.ReactNode;
}

const PageMainContainer = ({ children, className, outerClassName, variant, ...props }: PageMainContainerProps) => {
  return (
    <main
      className={cn('mobile:px-4 flex w-full flex-col items-center overflow-x-clip px-6 print:px-0', outerClassName)}
    >
      <div
        className={cn(containerVariants({ className, variant }))}
        {...props}
      >
        {children}
      </div>
    </main>
  );
};
export default PageMainContainer;
